// extracted by mini-css-extract-plugin
export default {"close":"Dialog_close__QjmzG"};